// styling
import styles from './style.module.scss';
// components
import LazyImage from '@components/LazyImage';
import Spring from '@components/Spring';
// assets
import theIdea from '@assets/uecomix-gifs/thinking.webp';
import thenDrawTheIdea from '@assets/uecomix-gifs/DRAW.webp';
import andShowTheIdea from '@assets/uecomix-gifs/showing-manga.webp';

const HowItWorks = () => {  
    const data = [
        {
            icon: theIdea,
            title: 'Step One - Fuel Your Creativity',
            text: 'Tap into your imagination and craft a vivid description of your vision, setting the stage for our AI platform to bring it to life.'
        },
        {
            icon: thenDrawTheIdea,
            title: 'Step Two - Input Descriptive Text',
            text: 'Paint a vivid picture with your words, detailing the scene, characters, and emotions you want to convey. Our AI technology will work its magic, transforming your text into visually stunning manga-style artwork.'
        },
        {
            icon: andShowTheIdea,
            title: 'Step Three - Download Your Artwork',
            text: 'Sit back and relax as our AI unleashes its creative prowess, generating four original and copyright-free images based on your description, ensuring full ownership and freedom to use in your comix.'
        },
    ];

    return (
        <div>
            <div className="container">
                <h1 className={styles.heading}>How It Works ?</h1>
                <div className={styles.list}>
                    {
                        data.map((item, index) => (
                            <Spring className={styles.list_item} key={index} index={index}>
                                <LazyImage className={styles.img} src={item.icon} alt={item.title} effect="opacity" />
                                <h5 className={styles.title}>{item.title}</h5>
                                <p className={styles.text}>{item.text}</p>
                            </Spring>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default HowItWorks